import {
  FormSelectChoice,
  apiFieldMappings,
  selectedStates,
  selectedStatesAlpha,
  selectedInsuranceFunds,
  selectedCharterTypes,
  selectedTransactionTypes,
  selectedResolutionTypes,
  selectedReport,
} from "../../refdata/FilterOptions";

interface filterChoicesInterface {
  [key: string]: any[];
}

export const summarizeFilterSelections = (
  filterName: string,
  selectedValues: string[],
  maxLength: any,
) => {
  // translate the currently selected raw values into a list of corresponding labels
  // e.g. from selectedStates maps ["1","2"] -> "Alabama, Arkansas"
  // if many are returned, "Alabama, Arkansas, ... (5 more)"
  // if all are selected, return "All"
  // Default value for Max Length is 5
  if (!selectedValues) {
    selectedValues = [];
  }
  const listOfLabels = filterChoices[filterName]
    .filter((fc: FormSelectChoice) => selectedValues.indexOf(fc.value) > -1)
    .map((fc: FormSelectChoice) => fc.label);
  if (listOfLabels.length === filterChoices[filterName].length) {
    return "All";
  } else if (maxLength == null) {
    return listOfLabels.join(", ");
  } else if (listOfLabels.length > maxLength) {
    return `${listOfLabels.splice(0, 5).join(", ")}... (${
      listOfLabels.length
    } more)`;
  } else {
    return listOfLabels.join(", ");
  }
};

export const allValuesForFilter = (filterName: string) => {
  return filterChoices[filterName].map((fc: FormSelectChoice) => fc.value);
};

export const allValuesForApiField = (fieldName: string) => {
  // same as above, but finding by api field name vs. filter name
  // grab the filter name based on the api field name
  const filterName = apiFieldMappings.multiSelect.filter(e => {
    return e.apiField === fieldName;
  })[0].filterName;
  // call the above function based on found filter name
  return allValuesForFilter(filterName);
};

export const addCheckedToSelectedOption = (
  options: FormSelectChoice[],
  selectedValue: any,
) => {
  const indexOfMatch = options.findIndex(e => {
    return e.value === selectedValue;
  });

  options.forEach((item, index) => {
    if (index === indexOfMatch) {
      options[index].checked = true;
    } else {
      options[index].checked = false;
    }
  });
  return options;
};

const yearList = () => {
  let years = [];
  const startYear = 1934;
  const endYear = new Date().getFullYear();
  for (var i = startYear; i <= endYear; i++) {
    years.push({ label: i.toString(), value: i.toString() });
  }
  return years;
};

const histYearList = () => {
  let years = [];
  const startYear = 1934;
  const endYear = new Date().getFullYear() - 1;
  for (var i = startYear; i <= endYear; i++) {
    years.push({ label: i.toString(), value: i.toString() });
  }
  return years;
};
const yearChoices = yearList();

const histYearChoices = histYearList();

const selectedStartDate = histYearChoices;
const selectedEndDate = histYearChoices;
const startFailYear = yearChoices;
const endFailYear = yearChoices;

export const filterChoices: filterChoicesInterface = {
  selectedStates,
  selectedStatesAlpha,
  yearChoices,
  histYearChoices,
  selectedStartDate,
  selectedEndDate,
  startFailYear,
  endFailYear,
  selectedInsuranceFunds,
  selectedCharterTypes,
  selectedTransactionTypes,
  selectedResolutionTypes,
  selectedReport,
};
